export const DEV_MY_TITLE_URL = '/dev_my_title_get_products';
export const PPD_DUMP_URL = '/get_ppd_dump';
export const AUTHOR_BOOK_INFORMATION_URL = '/get_author_book_information';
export const TOTAL_ROYALTY_PRODUCT = '/total_royalty_product';
export const DERIVATIVE_SOURCE_PRODUCT = '/derivative_source_product';
export const FINANCE_ADVANCE_REPORT_URL = '/get_finance_advance_data';
export const VALIDATE_TOKEN_RECEVIED_FROM_SACH_URL =
  '/validate_token_received_from_sach';
export const FINANCE_ROYALTY_RATE_V2 = '/finance_royalty_rate_v2';
export const ACCOUNTS_MASTER_URL = '/accounts_master';
export const FINANCE_ROYALTY_RATE_V1 = '/finance_royalty_rates_v1';
export const EXCHANGE_RATES = '/exchange_rates';
export const TIMESHEET = '/timesheet';
export const PIPELINE = '/pipeline_info';
export const AUTHOR_ADVANCE_INVOICE_GENERATE =
  '/author_advances_invoice_generated';
export const AUTHORS_EMAIL_ID = '/author_emailid';
export const TITLES_PUBLISHED = '/titles_published';
export const TITLES_IN_PRODUCTION = '/titles_in_production';
export const DEV_FD_PENDING_ACCEPTANCE_URL = '/dev_fd_pending_acceptance';
export const CHAP_TITLES_IN_PROD = '/chap_titles_in_prod';
export const ACCOUNTS_MASTER_NEW = '/accounts_master_new';
export const PPD_DUMP_NEW = '/ppd_dump_new';
export const AUTHOR_BOOK_INFO_NEW = '/author_book_info_new';
export const OSD_LOG_NEW = '/osd_log_new';
export const GET_USER_EMAIL = '/get_user_email';
export const AUTHOR_INFO = '/author_info';
export const ANNOUNCED_CONTRACTED = '/announced_contracted';
export const TRADE_SALE = '/trade_sale';
export const SOURCE_DERIVATIVE_PRODUCT_RELATION = '/source_derivative_rel';